export type ObserverCallback = (isIntersecting: boolean) => void;

export class ObserverInstance {
	private static observer: IntersectionObserver | null = null;
	private static get observerInstance() {
		if (!this.observer) {
			this.observer = new IntersectionObserver(this.globalCallback, {
				rootMargin: '5% 0px 5% 0px'
			});
		}
		return this.observer;
	}
	private static elements: Map<
		Element,
		{
			isIntersecting: boolean;
			callback: ObserverCallback;
		}
	> = new Map();

	private static globalCallback = (entries: IntersectionObserverEntry[]) => {
		for (const entry of entries) {
			const req = this.elements.get(entry.target);
			if (!req) continue;

			if (entry.isIntersecting !== req.isIntersecting) {
				req.isIntersecting = entry.isIntersecting;
				req.callback(entry.isIntersecting);
			}
		}
	};

	public static observe = (element: Element, callback: ObserverCallback) => {
		this.elements.set(element, {
			isIntersecting: false,
			callback
		});
		this.observerInstance.observe(element);
	};

	public static unobserve = (element: Element) => {
		this.elements.delete(element);
		this.observerInstance.unobserve(element);
	};
}
